import React from 'react'
import {VioDealTagContainer} from 'components/Offer/Shared/VariantLabel/Tags/VioDealTagContainer/VioDealTagContainer'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {Tag} from '@vio/atlas/Tag'
import {Tooltip, TooltipPlacement} from '@vio/atlas/Tooltip'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {OfferVariant} from '@vio/core/src/offer/types/OfferVariant'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

interface BaseProps {
  variant: OfferVariant
  anchorPrice?: number
  anchorPriceTotal?: number
  offer?: SearchOffer
  hasPadding?: boolean
}

export const VariantLabel: React.FC<BaseProps> = ({
  variant,
  anchorPrice,
  anchorPriceTotal,
  offer,
  hasPadding = false
}) => {
  const {isMobile, isDesktopXs} = useDeviceLayout()
  switch (variant) {
    case OfferVariant.OnlyOnVio:
      return (
        <Box paddingBottom={hasPadding ? 's300' : 's000'}>
          <VioDealTagContainer
            anchorPrice={anchorPrice}
            anchorPriceTotal={anchorPriceTotal}
            offer={offer}
          />
        </Box>
      )

    case OfferVariant.MemberDeal:
      return (
        <Box paddingBottom={hasPadding ? 's300' : 's000'}>
          <Tag variant="brand" iconStart={<Icon name="Sparkles" />}>
            <FormattedMessageWrapper
              id="memberDeals"
              defaultMessage="Member deal"
            />
          </Tag>
        </Box>
      )

    case OfferVariant.MemberPlusDeal:
      return (
        <Box paddingBottom={hasPadding ? 's300' : 's000'}>
          <Tag variant="brand" iconStart={<Icon name="Sparkles" />}>
            <FormattedMessageWrapper
              id="plusDeal"
              defaultMessage="{tag} deal"
              values={{
                tag: 'Plus'
              }}
            />
          </Tag>
        </Box>
      )

    case OfferVariant.GreatDeal:
      if (isMobile || isDesktopXs)
        return (
          <Box paddingBottom={hasPadding ? 's300' : 's000'}>
            <Tag variant="success" iconStart={<Icon name="Party" />}>
              <FormattedMessageWrapper
                id="greatDeal.badge"
                defaultMessage="Great deal"
              />
            </Tag>
          </Box>
        )
      return (
        <Box paddingBottom={hasPadding ? 's300' : 's000'}>
          <Tooltip
            placement={TooltipPlacement.BottomEnd}
            content={
              <Box maxWidth="232px">
                <FormattedMessageWrapper
                  id="greatDeal.description"
                  defaultMessage="This price is below this hotel's typical price range, based on the last 30 days."
                />
              </Box>
            }
          >
            <Tag variant="success" iconStart={<Icon name="Party" />}>
              <FormattedMessageWrapper
                id="greatDeal.badge"
                defaultMessage="Great deal"
              />
            </Tag>
          </Tooltip>
        </Box>
      )

    default:
      return null
  }
}
